import React from "react";
import { Navigate } from "react-router-dom";

import NotFound404 from "../pages/NotFound404";
import Evaluate from "../pages/Evaluate/index";

import Dashboard from "../pages/Dashboard";
import OPDCBox from "../pages/OPDCBOX";
import SetData from "../pages/SetData";
import ManageSorce from "../pages/ManageSorce";
import TestAPI from "../pages/TestAPI";
import RegisterTest from "../pages/Authentication/RegisterTest";
import LaOnline from "../pages/Leave/index";
import ProfileUser from "../pages/Profile/ProfileUser";
import ResorceOnline from "../pages/ResorceOnline";
import EntryWork from "../pages/EntryWork";
import RequestTex from "../pages/TaxAndDeduct/Tax";

import OPDCNews from "../pages/OPDCNews";

import OPDCTimeline from "../pages/OPDCTimeline";
import Login from "../pages/Login/index";
import SetDataLar from "../pages/Leave/SetData/SetDataLar";
import TESTluklen from "../pages/TESTPage";
import SetDataTool from "../pages/ResorceOnline/SetDataTool/SetDataTool";
import Reducetex from "../pages/TaxAndDeduct/Deduct";
import SetUserData from "../pages/EntryWork/SetUserData/SetUserData";
import TableLeave from "../pages/Leave/TableLeave";
import TableBorrowPage from "../pages/ResorceOnline/TableBorrowPage/TableBorrowPage";
import TestReport from "../pages/TestReport";
import DITLogin from "../pages/TestReport/DITLogin";
import DITLockScreen from "../pages/TestReport/DITLockScreen";

import LoginEoffice from "../pages/LoginEoffice/index";
import TestPDF from "../pages/TestReport/TestPDF";
import TaxAndDeduct from "../pages/TaxAndDeduct/TaxAndDeduct";

import ApiTesting from "../pages/ApiTesting";
import TabledataCommander from "../pages/Evaluate/TabledataCommander";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";

const authProtectedRoutes = [
  //Region
  { path: "/assessment", component: <Evaluate /> },
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/opdcbox", component: <OPDCBox /> },
  { path: "/setdata", component: <SetData /> },
  { path: "/managesorce", component: <ManageSorce /> },
  { path: "/testapi", component: <TestAPI /> },
  { path: "/registertest", component: <RegisterTest /> },
  { path: "/leave", component: <LaOnline /> },
  { path: "/leave/setdata", component: <SetDataLar /> },
  { path: "/leave/tableleave", component: <TableLeave /> },
  { path: "/profile", component: <ProfileUser /> },
  { path: "/resorcemanagement", component: <ResorceOnline /> },
  { path: "/resorcemanagement/setdata", component: <SetDataTool /> },
  { path: "/resorcemanagement/borrowtable", component: <TableBorrowPage /> },
  { path: "/entrywork", component: <EntryWork /> },
  { path: "/entrywork/setdata?", component: <SetUserData /> },
  { path: "/requesttax", component: <RequestTex /> },
  { path: "/requestdeducttax", component: <Reducetex /> },
  { path: "/taxanddeduct", component: <TaxAndDeduct /> },
  { path: "/news", component: <OPDCNews /> },
  { path: "/opdctimeline", component: <OPDCTimeline /> },
  { path: "/testpage", component: <TESTluklen /> },
  { path: "/testpdf", component: <TestPDF /> },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "/api-testing", component: <ApiTesting /> },
];

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/testreport", component: <TestReport /> },
  { path: "*", component: <NotFound404 /> },
  { path: "/login-eoffice", component: <LoginEoffice /> },
  { path: "/privacy", component: <PrivacyPolicy /> },
];

export { authProtectedRoutes, publicRoutes };
